import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  AccountHolder,
  UpdateAccountHolderClientNameBody,
  updateAccountHolderCompanyName,
} from "../../../services/accountService";
import useCreateAccountHolderNotesMutation from "./useCreateAccountHolderNotesMutation";

export default function useUpdateAccountHolderCompanyName() {
  const queryClient = useQueryClient();
  const { mutateAsync: createNote } = useCreateAccountHolderNotesMutation();

  return useMutation<string, string, UpdateAccountHolderClientNameBody>(
    (body) => updateAccountHolderCompanyName(body),
    {
      async onSuccess(_, body) {
        const accountConfigData = queryClient.getQueryData<AccountHolder>([
          "accountConfig",
          body.accountHolderCode,
        ]);

        queryClient.setQueryData(["accountConfig", body.accountHolderCode], {
          ...accountConfigData,
          companyName: body.companyName,
        });

        await createNote({
          accountHolderCode: body.accountHolderCode,
          noteContent: [
            {
              fieldName: "companyName",
              fromValue: accountConfigData?.companyName ?? "",
              toValue: body.companyName,
            },
          ],
        });

        queryClient.invalidateQueries([
          "accountConfig",
          body.accountHolderCode,
        ]);
      },
    }
  );
}
